const state = {
    competencies: [],
};

const mutations = {
    setCompetencies(state, value) {
        state.competencies = value;
    },
};

const actions = {};

const getters = {
    competencies: (state) => state.competencies,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
